import { BaseMapper } from '@/core/mapper';

const schema = {
  allowed_responses: {
    fromResponse: entity => _.get(entity, 'relationships.allowed_responses.data', [])
      .map(allowedResponse => ({
        response: allowedResponse.attributes,
        child_fields: _.get(allowedResponse, 'relationships.child_fields.data', [])
          .map(field => new AssessmentField(field, {
            allowedParentResponse: allowedResponse.attributes.text,
            parentUuid: entity.attributes.uuid,
          })),
      })),
    omitFromRequest: true,
  },
  flavour: {
    parseFrom: 'attributes.flavour',
    omitFromRequest: true,
  },
  label: {
    parseFrom: 'attributes.label',
    omitFromRequest: true,
  },
  name: {
    parseFrom: 'attributes.name',
    omitFromRequest: true,
  },
  question_id: {
    parseFrom: 'attributes.question_id',
    omitFromRequest: true,
  },
  required: {
    parseFrom: 'attributes.required',
    omitFromRequest: true,
  },
  secondary_text: {
    parse: 'attributes.secondary_text',
    omitFromRequest: true,
  },
  sort_order: {
    parseFrom: 'attributes.sort_order',
    omitFromRequest: true,
  },
  uuid: {
    parseFrom: 'attributes.uuid',
  },
};

class AssessmentField extends BaseMapper {
  constructor(entity, { allowedParentResponse, parentUuid } = {}) {
    super({ entity, schema });
    this.allowedParentResponse = allowedParentResponse;
    this.parentUuid = parentUuid;
  }

  flattened() {
    return [
      this,
      this.allowed_responses.map(allowedResponse => allowedResponse.child_fields.map(childField => childField.flattened())),
    ];
  }
}

AssessmentField.schema = schema;

export default AssessmentField;
